export class HomeService {
    constructor($http, apexApiUrl) {
        'ngInject'
        this.$http = $http
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Retrieve password validation options
     */
    retrievePasswordValidationOptions() {
        return this.$http.get(this.apexApiUrl + "home/password-validator/", {
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            });
    }

    validatePassword(options, firstname, lastname, password) {
        firstname = firstname ? firstname.toUpperCase() : '';
        lastname = lastname ? lastname.toUpperCase() : '';
        let passwordContainsUsername = false;

        if (options.CheckPasswordContainName && options.MinValToCheckName != null) {
            const firstNameMatches = firstname.length >= options.MinValToCheckName
                && password.toUpperCase().includes(firstname);
            const lastNameMatches = lastname.length >= options.MinValToCheckName
                && password.toUpperCase().includes(lastname)
            passwordContainsUsername = firstNameMatches || lastNameMatches;
        }

        const hasRequiredLength = options.RequiredLength > 0 ? password.length >= options.RequiredLength : true;
        const hasMaxRequiredLength = options.MaxLength > 0 ? password.length <= options.MaxLength : true;

        const hasLower = options.RequireLowercase ? /[a-z]/.test(password) : true;
        const hasUpper = options.RequireUppercase ? /[A-Z]/.test(password) : true;
        const hasDigit = options.RequireDigit ? /\d/.test(password) : true;
        const hasSpecial = options.RequireNonLetterOrDigit ? /(_|[^\w\d ])/.test(password) : true;

        const isValid = hasRequiredLength && hasLower && hasUpper &&
            hasDigit && hasSpecial && hasMaxRequiredLength && !passwordContainsUsername;

        const validationErrors = [];
        if (!hasRequiredLength) {
            validationErrors.push("Password must be at least " + options.RequiredLength + " characters");
        }
        if (passwordContainsUsername) {
            validationErrors.push("Password must not contain first or last name");
        }
        if (!hasMaxRequiredLength) {
            validationErrors.push("Passwords must be atmost " + options.MaxLength + " characters");
        }
        if (!hasLower) {
            validationErrors.push("Password must have at least 1 lower case letter ('a'-'z')");
        }
        if (!hasUpper) {
            validationErrors.push("Password must have at least 1 upper case letter ('A'-'Z')");
        }
        if (!hasDigit) {
            validationErrors.push("Password must have at least 1 digit");
        }
        if (!hasSpecial) {
            validationErrors.push("Password must have at least 1 special character");
        }

        return {
            isValid: isValid,
            errors: validationErrors
        };
    }

}
